import SettingsLayout from "../layout/SettingsLayout.vue";
// GeneralViews
import DashboardLayout from "../layout/DashboardLayout.vue";
import HomePage from "../pages/HomePage.vue";
import NotFound from "../pages/NotFoundPage.vue";
// Admin pages
import Appearance from "src/pages/Appearance.vue";
import Billing from "src/pages/Billing.vue";
import BotSettings from "src/pages/BotSettings.vue";
import ChatModels from "src/pages/ChatModels.vue";
import CreateBot from "src/pages/CreateBot.vue";
import Dashboard from "src/pages/Dashboard.vue";
import Demo from "src/pages/Demo.vue";
import Files from "src/pages/Files.vue";
import FollowPrompt from "src/pages/FollowPrompt.vue";
import Integration from "src/pages/Integration.vue";
import Localization from "src/pages/Localization.vue";
import Overview from "src/pages/Overview.vue";
import Prompt from "src/pages/Prompt.vue";
import Q_A from "src/pages/Q_A.vue";
import Subscription from "src/pages/Subscription.vue";
import AdvancedForm from "../pages/Advanced/AdvancedForm.vue";
import ChatHistory from "../pages/ChatHistory.vue";
import Chatbots from "../pages/Chatbots.vue";
import GeneralForm from "../pages/General/GeneralForm.vue";
import GoogleForm from "../pages/Google Drive/GoogleForm.vue";
import Links from "../pages/Links/Links.vue";
import Text from "../pages/Text/Text.vue";
import UserDataForm from "../pages/UserData/UserDataForm.vue";
import Policy from "../pages/Policy.vue";

const widget = localStorage.getItem("chosenWidget");

const routes = [
  {
    path: "/",
    name: "home",
    component: HomePage,
    meta: {
      requiresVisitor: false,
    },
  },
  {
    path: "/policy",
    name: "policy",
    component: Policy,
    meta: {
      requiresVisitor: false,
    },
  },
  {
    path: "/user",
    name: "user",
    component: DashboardLayout,
    redirect: widget ? "/user/dashboard" : "/user/chatbots",
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "websites",
        name: "Websites",
        component: Overview,
      },
      {
        path: "dashboard",
        name: "Dashboard",
        component: Dashboard,
      },
      {
        path: "appearance",
        name: "Appearance",
        component: Appearance,
      },
      {
        path: "text",
        name: "text",
        component: Text,
      },
      {
        path: "create_bot",
        name: "CreateBot",
        component: CreateBot,
      },
      {
        path: "chatbots",
        name: "Chatbots",
        component: Chatbots,
      },
      {
        path: "links",
        name: "links",
        component: Links,
      },
      {
        path: "files",
        name: "Files",
        component: Files,
      },
      {
        path: "subscription",
        name: "Subscription",
        component: Subscription,
      },
      {
        path: "q_a",
        name: "Q_A",
        component: Q_A,
      },
      {
        path: "prompt",
        name: "Prompt",
        component: Prompt,
      },
      {
        path: "google",
        name: "google",
        component: GoogleForm,
      },
      {
        path: "demo",
        name: "Demo",
        component: Demo,
      },
      {
        path: "billing",
        name: "Billing",
        component: Billing,
      },
      {
        path: "follow_prompt",
        name: "FollowPrompt",
        component: FollowPrompt,
      },
      {
        path: "/user/settings",
        name: "Settings",
        component: SettingsLayout,
        children: [
          {
            path: "general",
            name: "General",
            component: GeneralForm,
          },
          {
            path: "user_data",
            name: "UserData",
            component: UserDataForm,
          },
          {
            path: "chat_models",
            name: "ChatModels",
            component: ChatModels,
          },
          {
            path: "localization",
            name: "Localization",
            component: Localization,
          },
          {
            path: "advanced",
            name: "Advanced",
            component: AdvancedForm,
          },
        ],
      },
      {
        path: "integration",
        name: "Integration",
        component: Integration,
      },
      {
        path: "chat_history",
        name: "ChatHistory",
        component: ChatHistory,
      },

      {
        path: "bot_settings",
        name: "BotSettings",
        component: BotSettings,
      },
    ],
  },
  { path: "*", component: NotFound },
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
